// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"ed7e09bb","235":"0eb3250b","289":"16c6ef77","330":"f2d9a345","453":"c68702c2","471":"094b08a0","730":"f4907706"}[chunkId] + ".chunk.js";
};